import {texture} from "p3";
import definitions from "../../../definitions";
import Entity from "../../Entity";

export default class Shadow extends Entity {
    constructor(size = definitions.SHADOW_SIZE.CUSTOM) {
        super();

        this._size = size;

        this.offset = new PIXI.Point();
    }

    init() {
        super.init();

        let tex;
        switch (this._size) {
            case definitions.SHADOW_SIZE.SMALL: {
                tex = texture("char_shadow_small_00");
                break;
            }
            case definitions.SHADOW_SIZE.MEDIUM: {
                tex = texture("char_shadow_medium_00");
                break;
            }
            case definitions.SHADOW_SIZE.LARGE: {
                tex = texture("char_shadow_large_00");
                break;
            }
        }
        tex && this.setTexture(tex);
    }

    /**
     * @param {PIXI.Texture} texture
     */
    setTexture(texture) {
        this.addViewWithTexture(texture);
        this._view.anchor.set(0.5);
    }

    /**
     * @return {number}
     */
    get size() {
        return this._size;
    }
}